export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center">
                <i className="ri-tools-line text-2xl text-white"></i>
              </div>
              <div className="flex flex-col">
                <span className="text-xl font-bold leading-tight">DFPRO PARTNER</span>
                <span className="text-xs font-medium text-teal-400 leading-tight">Accesleads</span>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Spécialiste de la réparation de châssis, portes et volets. Service professionnel et garantie 2 ans.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://wa.me/32475585219"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center hover:bg-teal-700 transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl text-white"></i>
              </a>
              <a
                href="tel:0800.20.410"
                className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center hover:bg-teal-700 transition-colors cursor-pointer"
              >
                <i className="ri-phone-line text-xl text-white"></i>
              </a>
              <a
                href="mailto:info@df-pro.be"
                className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center hover:bg-teal-700 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line text-xl text-white"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6">Liens Rapides</h3>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Nos Services
                </a>
              </li>
              <li>
                <a href="#garanties" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Garanties
                </a>
              </li>
              <li>
                <a href="#diagnostic" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Visio-Diagnostic
                </a>
              </li>
              <li>
                <a href="#calculateur" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Calculateur de Prix
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-6">Nos Services</h3>
            <ul className="space-y-3">
              <li className="text-gray-300 text-sm">Réparation de châssis</li>
              <li className="text-gray-300 text-sm">Portes coulissantes</li>
              <li className="text-gray-300 text-sm">Volets roulants</li>
              <li className="text-gray-300 text-sm">Double & triple vitrage</li>
              <li className="text-gray-300 text-sm">Quincaillerie</li>
            </ul>
          </div>

          {/* Contact */}
          <div id="contact">
            <h3 className="text-lg font-bold mb-6">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-phone-line text-teal-400 text-lg mt-0.5"></i>
                <div>
                  <p className="text-sm text-gray-400 mb-1">Téléphone</p>
                  <a href="tel:0800.20.410" className="text-white font-medium hover:text-teal-400 transition-colors cursor-pointer">
                    0800.20.410
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-teal-400 text-lg mt-0.5"></i>
                <div>
                  <p className="text-sm text-gray-400 mb-1">Email</p>
                  <a href="mailto:info@df-pro.be" className="text-white font-medium hover:text-teal-400 transition-colors cursor-pointer">
                    info@df-pro.be
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-time-line text-teal-400 text-lg mt-0.5"></i>
                <div>
                  <p className="text-sm text-gray-400 mb-1">Horaires</p>
                  <p className="text-white text-sm">Lun-Ven: 8h-18h</p>
                  <p className="text-white text-sm">Sam: 9h-13h</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 DFPRO PARTNER. Tous droits réservés.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}